import { DeckGL } from "@deck.gl/react";
import { HeatmapLayer } from "@deck.gl/aggregation-layers";
import { Map } from "react-map-gl";
import "./EmissionHeatMap.css";
import { getMapboxToken } from "./config";

const EmissionsHeatMap = ({ data, type }) => {
  // Read at render time, not module load — the token arrives from /api/config.
  const MAPBOX_TOKEN = getMapboxToken();
  const INITIAL_VIEW_STATE = {
    longitude: -73.92,
    latitude: 40.8,
    zoom: 11,
    pitch: 0,
    bearing: 0,
  };

  const layers = [];
  if (type === "heatmap") {
    const redYellowColorRange = [
      [128, 0, 38, 80], // 900 ppm
      [189, 0, 38, 80],
      [227, 26, 28, 80],
      [252, 78, 42, 80],
      [253, 141, 60, 80],
      [254, 178, 76, 80],
      [254, 217, 118, 80],
      [255, 255, 178, 80],
      [255, 255, 229, 80], // 0 ppm
    ];

    layers.push(
      new HeatmapLayer({
        id: "heatmap",
        data,
        getPosition: (d) => [d.longitude, d.latitude],
        getWeight: (d) => d.intensity,
        radiusPixels: 60,
        aggregation: "MEAN",
        colorRange: redYellowColorRange,
      })
    );
  }

  if (type === "heatmap-multi") {
    const gasColors = {
      CO2: [28, 60, 28, 140], // #1c3c1c
      NOx: [77, 156, 50, 140], // #4d9c32
      PM: [207, 255, 142, 140], // #cfff8e
    };

    Object.entries(gasColors).forEach(([gas, color]) => {
      layers.push(
        new HeatmapLayer({
          id: `heatmap-${gas}`,
          data,
          getPosition: (d) => [d.longitude, d.latitude],
          getWeight: (d) => d[gas],
          radiusPixels: 60,
          aggregation: "MEAN",
          colorRange: [
            [0, 0, 0, 0],
            [color[0], color[1], color[2], 200],
            [color[0], color[1], color[2], 140],
            [color[0], color[1], color[2], 80],
          ],
        })
      );
    });
  }

  return (
    <div className="heatmap-container">
      <DeckGL
        initialViewState={INITIAL_VIEW_STATE}
        controller={true}
        layers={layers}
        style={{ width: "100%", height: "100%" }}
        parameters={{
          preserveDrawingBuffer: true,
        }}
      >
        <Map
          mapboxAccessToken={MAPBOX_TOKEN}
          mapStyle="mapbox://styles/mapbox/dark-v10"
          reuseMaps
          preventStyleDiffing
          attributionControl={false}
          preserveDrawingBuffer={true}
        />
      </DeckGL>
      <div className="heatmap-legend">
        <div className="legend-gradient" />
        <div className="legend-labels">
          {[900, 750, 600, 450, 300, 150, 0].map((v, i) => (
            <div key={i}>{v} ppm</div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EmissionsHeatMap;
